var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    { attrs: { id: "attribution", title: "Attribution" } },
    [
      _c("template", { slot: "copy" }, [
        _c("p", [
          _vm._v(
            "\n      Attribution is required by MIT, SIL OFL, and CC BY licenses. Downloaded Font Awesome Free files already contain embedded comments with sufficient\n      attribution, so "
          ),
          _c("strong", [
            _vm._v("you shouldn't need to do anything additional"),
          ]),
          _vm._v(" when using these files normally.\n    "),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("\n      We've kept attribution comments terse, so "),
          _c("strong", [
            _vm._v(
              "we ask that you do not actively work to remove them from files, especially code"
            ),
          ]),
          _vm._v(
            ". They're a\n      great way for folks to learn about Font Awesome.\n    "
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }